import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Panel, Text } from '@bigcommerce/big-design';
import Container from './ui/Container';

export default function MainView({ activeTab }) {

    const navigate = useNavigate();
    const handleClick = (link) => {
        navigate(link, { replace: true });
    };

    return (
        <Container>
            <p>main panel</p>
        </Container>
    );
}
